import { platforms } from "@/data/content";

// Slow editorial marquee of platform names.
export default function Marquee() {
  const items = [...platforms, ...platforms];
  return (
    <div className="relative overflow-hidden border-y border-line bg-mist py-6" data-testid="platform-marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-mist to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-mist to-transparent" />
      <div className="flex w-max animate-marquee items-center gap-16">
        {items.map((p, i) => (
          <span key={i} className="flex items-center gap-16 font-serif text-2xl font-medium text-navy/70 md:text-3xl">
            {p.name}
            <span className="h-1.5 w-1.5 rounded-full bg-sky" />
          </span>
        ))}
      </div>
    </div>
  );
}
